import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import moment from 'moment';
import EmbedLiveStream from '../components/embeds/livestream';
import EmbedPlatforms from '../components/embeds/platforms';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

import './css/livestream.css';

class PortalServiceLiveStream extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: parseInt(this.props.service),
				name: '',
			},

			clientId: '',
      embed: '',
			streams: [],
			banned: [],
			
      //PortalStage: null,
			PortalStreams: null,
		};
		this.setStreamStatus = this.setStreamStatus.bind(this);
    this.kickstreamer = this.kickstreamer.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${server}/v3/service/livestream`, params);
    consoleLog(x.data);
		EventEmitter.emit('/client', y);
		
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle('Live Stream', x.data.servicename);
			}
			//this.renderLiveFeed(x.data.stage);

			//let clientId = '';
			//console.log(x.data.stage.rtmp.connected);
			//if( x.data.stage.rtmp.connected )
			let clientId = x.data?.stage?.rtmp?.connected || '';
			//console.log(clientId);

			this.setState({streams: x.data.streams?x.data.streams:[], clientId, banned: x.data.banned?x.data.banned:[]});
		}

		const PortalStreams = EventEmitter.addListener(`/portal/streams`, async data => {
		  //this.renderLiveFeed( data.Stage );
			console.log(data);
			if( data.service === this.state.service.id ) this.setState({streams: data.streams, clientId: data.clientId, banned: data.banned?data.banned:[]});
			//this.setState({next: data.Next, socials: data.Socials, meta: data.Meta, users: x.data.Users?x.data.Users:{} });
		}); this.setState({PortalStreams});

		this.setState({livetime: setInterval(()=>{
      try {
				let streams = this.state.streams;
				//console.log(streams);

				for( let i in streams ) {
					let start = new Date(streams[i].connectCreated);
					let time = new Date();
					time = Math.abs(time.getTime()/1000-start.getTime()/1000);
					
					let h = Math.floor(time / 3600);
					let m = Math.floor(time % 3600 / 60);
					let s = Math.floor(time % 3600 % 60);
					//console.log(`${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`);
					streams[i].current = `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
					streams[i].percent = streams[i].audio.mtime ? Math.floor(((streams[i].audio.mtime+60000)-Date.now())/60000*100) : 100;
					if( streams[i].percent < 0 ) streams[i].percent = 0;
				}

				this.setState(streams);

        /*let start = new Date(this.state.stage.rtmp.time);
        let time = new Date();
        

        time = Math.abs(time.getTime()/1000-start.getTime()/1000);

        //let time = Math.floor(Date.now()/1000-(this.state.meta.azura.time > this.state.meta.rtmp.time ? this.state.meta.azura.time : this.state.meta.rtmp.time));
        let h = Math.floor(time / 3600);
        let m = Math.floor(time % 3600 / 60);
        let s = Math.floor(time % 3600 % 60);
        this.setState({livetimestamp: `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`});

        //return <>00:01</>*/
      } catch(error) {
        //return <>00:00</>
      }

		}, 1000)});
		return ()=>{
			clearInterval(this.state.livetime);
		}
	}

	componentWillUnmount() {
		if( this.state.PortalStreams ) this.state.PortalStreams.remove();
	}


	async setStreamStatus(uid, status) {
		if( status === 1 && !window.confirm("Are you sure you wish to prevent this member from streaming on your station? The disallowed DJ will remain inactive until you or another member of staff re-allow streaming.")) {
			return;
		}
		if( status === 0 && !window.confirm("Are you sure you wish to allow streaming again?")) {
			return;
		}
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('uid', uid);
		params.append('status', status);
		await putApi(`${this.context.worker[this.props.service]}/v3/admin/accounts/status`, params);
	}


	async kickstreamer(clientId, status) {
		if( status === 1 && !window.confirm("Are you sure you wish to ban this streamer?") ) return; 
		const value = this.context;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('clientId', clientId);
		params.append('status', status);
		let x = await putApi(`${value.worker[this.state.service.id]}/v3/service/livestream/kick`, params);
		x = null;
	}


  render() {
		const user = this.context;
		
		const streams = this.state.streams.map((e,i) => {
			//console.log(e);
			//let date = new Date(e.connectCreated);

			//---- How do we calculate and set accordingly ?

			
			let technical = {
				audio: {
					audiorate: 320,
					levels: 'waiting'
				},
				video: {
					codec: 'H264',
					fps: 30,
					videorate: [1000,1000],
				},
			};

			//let levels = e.audio.levels;
			//console.log(e.audio.levels);
			switch(true) {
				/*case e.audio.levels>=-100:
					technical.audio.levels = 'waiting';
				break;*/
				case e.audio.levels===0:
					technical.audio.levels = 'high';
				break;
				case e.audio.levels>=-8:
					technical.audio.levels = 'ok';
				break;
				case e.audio.levels>=-90:
					technical.audio.levels = 'low';
				break;
				default:
					technical.audio.levels = 'waiting';
				break;
			}

			
			//let percent = e.audio.mtime ? Math.floor(((e.audio.mtime+60000)-Date.now())/60000*100) : 100;
			//console.log(e.audio.mtime, percent);




			//console.log(e);

			if( e.audio?.levels ) {
				if( e.audio.levels < -80 ) technical.audio.levels = 'waiting';
				if(e.audio.levels >= -80 && e.audio.levels < -30 ) technical.audio.levels = 'none';
				if(e.audio.levels >= -30 && e.audio.levels < -8 ) technical.audio.levels = 'low';
				if(e.audio.levels >= 8 ) technical.audio.levels = 'ok';
				//technical.audio.levels = 'ok';
			}
			if( e.video ) {
				let bitlow = 0;
				let bithigh = 0;
				bitlow = Math.round(((e.video.width * e.video.height) / 1000 * e.video.fps * 0.1)/500)*500;
				bithigh = Math.round(((e.video.width * e.video.height) / 1000 * e.video.fps * 0.15)/500)*500;

				if( bitlow > 6000 ) bitlow = 6000;
				if( bithigh > 6000 ) bithigh = 6000;

				//console.log(bitlow, bithigh);
				technical.video.videorate = [bitlow, bithigh];
			}

			return (
				<React.Fragment key={i}>
					<tr>
						<td colSpan={2}>
							<div className="d-flex align-items-center">
								<div className="avatar avatar-sm me-2 avatar-rounded">
									<img src={`https://cloud.ultrastream.io${e.user.avatar}`} alt="img" />
								</div>
								<div>
									<div className="lh-1">
										<span>{e.user.title?e.user.title:e.user.username}</span>
									</div>
								</div>
							</div>
						</td>
						<td>
							{e.current}
						</td>
						<td>
							{e.clientId === this.state.clientId ?
								<span className="badge rounded-pill bg-danger">LIVE</span>
							:
								<span className="badge rounded-pill bg-danger-transparent">CONNECTED</span>
							}
						</td>
							
						<td>
							<Dropdown>
								<Dropdown.Toggle variant="primary" id="dropdown-basic" size="sm">
									Actions
								</Dropdown.Toggle>

								<Dropdown.Menu>
									<Dropdown.Item onClick={()=>this.kickstreamer(e.clientId, 0)}>Reset Streamer</Dropdown.Item>
									<Dropdown.Item onClick={()=>this.kickstreamer(e.clientId, 1)}>Ban Streamer</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</td>
					</tr>
					<tr>
						<td className="table-success">Audio</td>
						{e.audio ?
							<>
								<td className="table-success">Codec: {e.audio?.codec}</td>
								<td className="table-success">Samplerate: {e.audio?.samplerate}</td>
								{e.audio.audiorate < technical.audio.audiorate ?
									<td className="table-danger">
										Audiorate: {e.audio?.audiorate}&nbsp;
										<span class="badge bg-danger">{technical.audio.audiorate}</span>
									</td>
								:
									<td className="table-success">Audiorate: {e.audio?.audiorate}</td>
								}
								{technical.audio.levels === 'waiting' &&
									<td className="table-warning">Levels: Waiting</td>
								}
								{technical.audio.levels === 'low' &&
									<td className="table-danger" style={{position: 'relative'}}><div className="audio-waiting" style={{width: `${e.percent}%`}}></div>Levels: Low {e.audio.levels} DB&nbsp;<span class="badge bg-danger">-8 DB</span></td>
								}
								{technical.audio.levels === 'ok' &&
									<td className="table-success" style={{position: 'relative'}}><div className="audio-waiting" style={{width: `${e.percent}%`}}></div>Levels:&nbsp;<span class="badge bg-success">Perfect {e.audio.levels} DB</span></td>
								}
								{technical.audio.levels === 'high' &&
									<td className="table-danger" style={{position: 'relative'}}><div className="audio-waiting" style={{width: `${e.percent}%`}}></div>Levels: High {e.audio.levels} DB&nbsp;<span class="badge bg-danger">0 DB</span></td>
								}
								
							</>
						:
							<td className="table-success" colSpan={4}>Waiting ...</td>
						}
						
					</tr>
					<tr>
						<td className="table-success">Video</td>
						{e.video ?
							<>
								<td className="table-success">Codec: {e.video?.codec}</td>
								<td className="table-success">{e.video?.width} x {e.video?.height}</td>
								{e.video.fps > technical.video.fps ?
									<td className="table-danger">
										FPS: {e.video?.fps}&nbsp;
										<span class="badge bg-danger">{technical.video.fps}</span>
									</td>
								:
									<td className="table-success">FPS: {e.video?.fps}</td>
								}

								{(e.video.videorate < technical.video.videorate[0] || e.video.videorate > technical.video.videorate[1] ) ?
									<td className="table-danger">
										Videorate: {e.video?.videorate}&nbsp;
										<span class="badge bg-danger">{technical.video.videorate[0]} - {technical.video.videorate[1]}</span>
									</td>
								:
									<td className="table-success">Videorate: {e.video?.videorate}</td>
								}

								
							</>
						:
							<td className="table-success" colSpan={4}>Waiting ...</td>
						}
						
					</tr>
				</React.Fragment>
			)
		});

		const banned = this.state.banned.map((e,i) => {
			return (
				<tr key={i}>
					<td colSpan={2}>
						<div className="d-flex align-items-center">
							<div className="avatar avatar-sm me-2 avatar-rounded">
								<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="img" />
							</div>
							<div>
								<div className="lh-1">
									<span>{e.title?e.title:e.username}</span>
								</div>
							</div>
						</div>
					</td>
					<td></td>
					<td>
						Streaming Disallowed! <button type="button" class="btn btn-primary btn-sm" onClick={()=>this.setStreamStatus(e.id, 0)}>Allow</button>
					</td>
				</tr>
			)
		});

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Live Stream</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
                <Col lg={12}>
                  <div className="card custom-card " style={{position: 'relative'}}>
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Live Stream</span>
													<p className="fs-13 text-muted mb-0">Watch the live stream</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										<div style={{position: 'relative', display: 'inline-block'}}>
                      <EmbedLiveStream embed={this.state.service} />
                    </div>

                  </div>
                </Col>
								<Col style={{position: 'relative'}}>
									
									
										
								</Col>
							</Row>
							<EmbedPlatforms service={this.state.service} />
							
							<Row className="pt-4">
                <Col xl={12}>
                  <div className="card custom-card">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
                        Admin controller
                      </div>
                    </div>
                    	<div className="card-body p-0">
												<div className="table-responsive">
													<table className="table text-nowrap table-hover">
														<thead>
															<tr>
																<th scope="col" colSpan={2}>Streamer</th>
																<th scope="col">Streaming</th>
																<th scope="col">Status</th>
																<th scope="col"></th>
															</tr>
														</thead>
														<tbody>
															{banned}
															{streams}
														</tbody>
												</table>
											</div>
										</div>
                  </div>
                </Col>
              </Row>
            </div>
					</div>
				}
			</>
		);
	}
}

const Stream = props => {
  const { service } = useParams();
  return <PortalServiceLiveStream service={service} {...props} />
}
export default Stream;